/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { CheckUsageDto, ComponentListItemDto } from '@gh/builder-shared-data';

export type ComponentListItem = ComponentListItemDto;
export type ComponentListCheckUsage = CheckUsageDto;

export const DEFAULT_COMPONENT_FILTER = { showDeleted: false, searchString: '' };
